//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {columnFormatterMixin} from '@/mixins/columnFormatterMixin'
import {mapActions, mapState, mapMutations} from 'vuex'
import ShoppingCartDeleteDialog from '@/frontend/components/common/shopping-cart-delete-dialog.vue'
import ProductRow from '@/frontend/components/common/product-row.vue'
import {attributesMixin} from '@/mixins/attributesMixin'
import {customAttributeCodes} from '@/frontend/enums/customAttributeCodes'
export default {
  name: 'ShoppingCart',
  components: {
    ShoppingCartDeleteDialog,
    ProductRow,
  },
  mixins: [columnFormatterMixin, attributesMixin],
  middleware: ['auth'],
  props: {
    section: {
      type: Object,
      required: true,
    },
  },
  data: () => {
    return {
      newProducts: undefined,
      additionalInfo: '',
      confirmationDialogVisibility: false,
      cartLoading: true,
    }
  },
  computed: {
    ...mapState('shoppingCart', [
      'cartItems',
      'cartItemCount',
      'salesTax',
      'shippingPrice',
      'subTotal',
      'grandTotal',
    ]),
    catalogItemsWithAttributes() {
      return this.cartItems
        .filter((item) =>
            item.itemTypeData?.attributes.find(
              (attribute) => attribute.code === customAttributeCodes.OrderSnapshotId
            ) === undefined
        )
        .map((item) => {
          return {
            attributes: item.itemTypeData?.attributes.map((attribute) => {
              return this.mapAttributeValue(attribute)
            }),
            ...item,
          }
        })
    },
    configuratorItemsWithAttributes() {
      const cartItems = this.cartItems
        .filter((item) =>
          item.itemTypeData?.attributes.find(
            (attribute) => attribute.code === customAttributeCodes.OrderSnapshotId
          )
        )
        .map((item) => {
          return {
            attributes: item.itemTypeData?.attributes
              .filter((attribute) => {
                if (attribute.code === customAttributeCodes.OrderSnapshotId) {
                  item.orderSnapshotId = attribute.value
                  return false // skip attribute
                }
                return true
              })
              .map((attribute) => {
                return this.mapAttributeValue(attribute)
              }),
            ...item,
          }
        })
      const groupedCartItems = this.groupBy(cartItems, 'orderSnapshotId')
      return groupedCartItems
    },
  },
  watch: {
    cartItems: {
      handler(val) {
        this.updateSubTotal()
        this.updateGrandTotal()
      },
      deep: true,
    },
  },
  async mounted() {
    this.cartLoading = true
    await this.frontendGetBySessionId()
    this.cartLoading = false
  },
  methods: {
    ...mapMutations('shoppingCart', [
      'updateSubTotal',
      'updateGrandTotal',
      'setAdditionalInfo',
    ]),
    ...mapActions('shoppingCart', [
      'frontendGetBySessionId',
      'updateQuantityFrontend',
      'deleteCartItemFrontend',
      'getSalesTax',
    ]),
    ...mapActions('backoffice/products', ['fetchRetailProducts']),
    async updateCartItemQuantity({id, quantity}) {
      this.isLoading = true
      try {
        await this.updateQuantityFrontend({id, quantity})
      } finally {
        this.isLoading = false
      }
    },
    async deleteCartItem() {
      this.isLoading = true
      try {
        if (!this.currentItem || !this.currentItem.itemID) {
          return
        }

        if (this.currentItem.isSnapshotId) {
          this.cartItems
            .filter((item) => item.orderSnapshotId === this.currentItem.itemID)
            .forEach(async (item) => {
              await this.deleteCartItemFrontend(item.id)
            })
        } else {
          await this.deleteCartItemFrontend(this.currentItem.itemID)
        }
      } finally {
        this.isLoading = false
        this.currentItem = undefined
        this.closeDialog()
      }
    },
    closeDialog() {
      this.confirmationDialogVisibility = false
      this.currentItem = undefined
    },
    deleteCartItemDialog(itemID, isSnapshotId = false) {
      this.confirmationDialogVisibility = true
      this.currentItem = {itemID, isSnapshotId}
    },
    continueShopping() {
      window.location = `/configurator`
    },
    checkout() {
      this.setAdditionalInfo({
        notes: this.additionalInfo,
      })
      this.$router.push('checkout')
    },
    deleteConfiguratorItems(snapshotId) {
      this.deleteCartItemDialog(snapshotId, true)
    },
    editConfiguratorItems(snapshotId) {
      window.location = `/configurator?snapshotId=${snapshotId}`
    },
    groupBy(array, key) {
      return array.reduce(function(rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv
      }, {})
    },
  },
}
